import React, { ChangeEvent, Dispatch, SetStateAction } from "react";

import { RequiredInput } from "../../../common/components/FormError.tsx";
import { IDwellingAddress } from "../interfaces";

export interface DwellingAddressFormProps {
  dwellingAddress: IDwellingAddress;
  setDwellingAddress: Dispatch<SetStateAction<IDwellingAddress>>;
}

const DwellingAddressForm = ({
  dwellingAddress,
  setDwellingAddress,
}: DwellingAddressFormProps) => {
  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.currentTarget;
    updateDwellingAddress(name, value);
  };
  const updateDwellingAddress = (dwellingAddressField: string, value: any) => {
    setDwellingAddress({
      ...dwellingAddress,
      [dwellingAddressField]: value,
    });
  };

  return (
    <div className="d-flex flex-wrap gap-3">
      <div
        className="d-flex flex-column justify-content-end"
        style={{ width: window.innerWidth >= 768 ? "200px" : "100%" }}
      >
        <label className={"w-100 add-prop-label ms-2"}>
          Numéro de cave : <RequiredInput />
        </label>
        <input
          className="w-100 add-prop-input"
          type="text"
          name="cellarNumber"
          value={dwellingAddress.cellarNumber}
          onChange={handleChange}
          placeholder="Si absence indiquez SO"
        />
      </div>
      <div
        className="d-flex flex-column"
        style={{ width: window.innerWidth >= 768 ? "150px" : "100%" }}
      >
        <label className="w-100 add-prop-label ms-2">
          N° parking extérieur :
        </label>
        <input
          className="w-100 add-prop-input"
          type="text"
          name="outdoorParkingNumber"
          value={dwellingAddress.outdoorParkingNumber}
          onChange={handleChange}
        />
      </div>
      <div
        className="d-flex flex-column"
        style={{ width: window.innerWidth >= 768 ? "150px" : "100%" }}
      >
        <label className="w-100 add-prop-label ms-2">
          N° parking intérieur :
        </label>
        <input
          className="w-100 add-prop-input"
          type="text"
          name="indoorParkingNumber"
          value={dwellingAddress.indoorParkingNumber}
          onChange={handleChange}
        />
      </div>
      <div
        className="d-flex flex-column"
        style={{ width: window.innerWidth >= 768 ? "150px" : "100%" }}
      >
        <label className="w-100 add-prop-label ms-2">N° box garage :</label>
        <input
          className="w-100 add-prop-input"
          type="text"
          name="garageBoxNumber"
          value={dwellingAddress.garageBoxNumber}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};
export default DwellingAddressForm;
